export type AppointmentStatus =
  | 'scheduled'
  | 'confirmed'
  | 'completed'
  | 'cancelled'
  | 'no_show'

export type AppointmentType =
  | 'consultation'
  | 'surgery'
  | 'check_up'
  | 'vaccination'
  | 'follow_up'
  | 'emergency'
  | 'other'

export interface AppointmentListItem {
  id: number
  practice_id: number
  patient_id: number
  client_id: number
  veterinarian_id: number | null
  consultation_id: number | null
  veterinarian_name: string | null
  patient_name: string | null
  client_name: string | null
  scheduled_at: string
  duration_minutes: number
  appointment_type: AppointmentType
  reason: string | null
  status: AppointmentStatus
  pre_consult_weight_kg: string | null
  created_at: string
}

export interface AppointmentRead extends AppointmentListItem {
  notes: string | null
  updated_at: string
}

export interface AppointmentCreate {
  practice_id: number
  patient_id: number
  client_id: number
  veterinarian_id?: number | null
  scheduled_at: string
  duration_minutes?: number
  appointment_type?: AppointmentType
  reason?: string | null
  notes?: string | null
}

export interface AppointmentUpdate {
  veterinarian_id?: number | null
  scheduled_at?: string
  duration_minutes?: number
  appointment_type?: AppointmentType
  reason?: string | null
  status?: AppointmentStatus
  notes?: string | null
  pre_consult_weight_kg?: string | null
}

export const STATUS_LABELS: Record<AppointmentStatus, string> = {
  scheduled: 'Scheduled',
  confirmed: 'Confirmed',
  completed: 'Completed',
  cancelled: 'Cancelled',
  no_show: 'No Show',
}

export const STATUS_COLORS: Record<AppointmentStatus, { color: string; bg: string }> = {
  scheduled: { color: 'var(--warning-text)', bg: 'var(--warning-bg)' },
  confirmed: { color: 'var(--success-text)', bg: 'var(--success-bg)' },
  completed: { color: 'var(--text-2)', bg: 'var(--surface-alt)' },
  cancelled: { color: 'var(--text-3)', bg: 'var(--surface-alt)' },
  no_show: { color: 'var(--danger-text)', bg: 'var(--danger-bg)' },
}

export const TYPE_LABELS: Record<AppointmentType, string> = {
  consultation: 'Consultation',
  surgery:      'Surgery',
  check_up:     'Check-up',
  vaccination:  'Vaccination',
  follow_up:    'Follow-up',
  emergency:    'Emergency',
  other:        'Other',
}

export const TYPE_COLORS: Record<AppointmentType, { color: string; bg: string }> = {
  consultation: { color: 'var(--text-2)', bg: 'var(--surface-alt)' },
  surgery:      { color: 'var(--text-2)', bg: 'var(--surface-alt)' },
  check_up:     { color: 'var(--text-2)', bg: 'var(--surface-alt)' },
  vaccination:  { color: 'var(--text-2)', bg: 'var(--surface-alt)' },
  follow_up:    { color: 'var(--text-2)', bg: 'var(--surface-alt)' },
  emergency:    { color: 'var(--danger-text)', bg: 'var(--danger-bg)' },
  other:        { color: 'var(--text-3)', bg: 'var(--surface-alt)' },
}
